<template>
  <v-card>
    <v-card-title v-if="false">
      <!-- {{ item.type || type }}-->
      Editar
    </v-card-title>
    <v-card-text class="pt-4" v-if="!loading">
      <!-- additional data -->
      <div style="min-height: 100px">
        <div v-if="!item.type">
          <v-chip-group v-model="item.type">
            <v-chip v-for="type in types" :key="type.value" filter label class="mb-1" :value="type.value">{{
              type.text
            }}</v-chip>
          </v-chip-group>
        </div>
        <!-- glucosa -->
        <div v-if="item.type == 'glucose'">
          <v-text-field
            style="font-size: 16pt; text-align: right"
            type="number"
            label="Glucosa"
            suffix="mg/dL"
            pattern="\d*"
            v-model="item.value"
          ></v-text-field>

          <v-chip-group v-model="item.meal_context">
            <v-chip v-for="mc in meal_context" :key="mc.value" filter label class="mb-1" :value="mc.value">{{
              mc.text
            }}</v-chip>
          </v-chip-group>

          <v-chip-group v-model="item.meal">
            <v-chip v-for="meal in meals" :key="meal.value" filter label class="mb-1" :value="meal.value">{{
              meal.text
            }}</v-chip>
          </v-chip-group>
        </div>

        <!-- meals -->
        <div v-if="item.type == 'meal'">
          <v-chip-group v-model="item.meal">
            <v-chip v-for="meal in meals" :key="meal.value" filter label class="mb-1" :value="meal.value">{{
              meal.text
            }}</v-chip>
          </v-chip-group>

          <v-textarea rows="1" auto-grow :label="mealInputLabel()" v-model="item.value"></v-textarea>
          <div v-if="false" style="margin: auto; text-align: center">
            <!-- TODO: Remove-->
            <v-rating hover size="40" v-model="item.rating" color="orange" background-color="orange"></v-rating>
          </div>
        </div>

        <!-- exercise -->
        <div v-if="item.type == 'exercise'">
          <v-chip-group v-model="item.what">
            <v-chip v-for="item in ['andar', 'nadar']" :key="item" filter label class="mb-1" :value="item">{{
              item
            }}</v-chip>
          </v-chip-group>
          <v-chip-group v-model="item.intensity">
            <v-chip
              v-for="(item, i) in ['Relajado', 'Medio', 'Intenso']"
              :key="item"
              filter
              label
              class="mb-1"
              :value="i + 1"
              >{{ item }}</v-chip
            >
          </v-chip-group>
          <div style="font-size: 30px; margin-top: 15px">
            {{ formatTime(item.value) }}
          </div>
          <v-slider :max="180" :min="10" :step="5" v-model="item.value" hide-details> </v-slider>
        </div>

        <!-- intake -->
        <div v-if="type == 'intake'">
          <v-chip-group v-model="item.what">
            <v-chip v-for="item in intakes" :key="item.value" filter label class="mb-1" :value="item.value">{{
              item.text
            }}</v-chip>
          </v-chip-group>

          <v-text-field
            style="font-size: 16pt; text-align: right"
            type="number"
            label="cantidad"
            :suffix="'' + labelfor(item)"
            pattern="\d*"
            v-model="item.value"
          ></v-text-field>

          <div style="text-align: right">
            <v-btn depressed @click="valueIncrease(-1)" class="mr-2"><v-icon>mdi-minus</v-icon></v-btn>
            <v-btn depressed @click="valueIncrease(1)"><v-icon>mdi-plus</v-icon></v-btn>
          </div>
        </div>
        <v-text-field label="Notas para tu coach" v-model="item.notas" clearable></v-text-field>
        <v-text-field label="Cuándo" type="datetime-local" v-model="item.when"></v-text-field>
      </div>
    </v-card-text>
    <v-card-text v-else>
      <div style="height: 200px"></div>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="cancel" depressed color="secondary">cancel</v-btn>
      <v-btn @click="deleteItem()" depressed color="error">delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="save" depressed color="success" :loading="loading">save</v-btn>
    </v-card-actions>
    <div style="height: 10px"></div>
  </v-card>
</template>

<script>
import api from '@/assets/api'
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'meal',
      required: false, //only when creating a new event
    },
  },
  watch: {
    id() {
      this.fetchEvent()
    },
  },
  data() {
    return {
      item: {
        type: null,
        meal: null,
      },
      types: [
        { value: 'meal', text: 'Comidas' },
        { value: 'glucose', text: 'Glucosa' },
        { value: 'exercise', text: 'Ejercicio' },
        { value: 'intake', text: 'Intake' },
      ],
      meals: [
        { value: 'breakfast', text: 'Desayuno' },
        { value: 'morning-snack', text: 'Media Mañana' },
        { value: 'lunch', text: 'Comida' },
        { value: 'evening-snack', text: 'Merienda' },
        { value: 'dinner', text: 'Cena' },
        { value: 'other', text: 'Otro' },
      ],
      meal_context: [
        { value: 'before', text: 'Antes' },
        { value: 'after', text: 'Después' },
      ],
      intakes: [
        { value: 'water', text: 'Agua', units: ['vaso', 'vasos'] },
        { value: 'fruit', text: 'Fruta', units: ['pieza', 'piezas'] },
        { value: 'milk', text: 'Leche', units: ['vaso', 'vasos'] },
        { value: 'vegetables', text: 'Verduras', units: ['ración', 'raciones'] },
      ],
      loading: false,
    }
  },
  computed: {},
  methods: {
    mealInputLabel() {
      const defaultt = '¿qué has comido?'
      const meal = this.item.meal
      console.log('meal', meal)
      if (!meal) return defaultt
      const map = {
        breakfast: '¿Qué has desayunado?',
        lunch: '¿Qué has comido?',
        dinner: '¿Qué has cenado?',
        'morning-snack': '¿Cuál ha sido tu media mañana?',
        'evening-snack': '¿Qué has merendado?',
        other: '¿Que te has pimplado?',
      }
      return map[meal] || 'lala'
    },
    labelfor(item) {
      if (item.type == 'intake') {
        const e = this.intakes.find((x) => x.value == item.what)
        if (e) {
          const i = item.value == 1 ? 0 : 1
          return e.units[i]
        } else {
          return ''
        }
      } else {
        return undefined
      }
    },
    valueIncrease(v) {
      if (!this.item.value) this.item.value = 0
      this.item.value = +this.item.value + v
      this.item = { ...this.item } //otherwise it doesn't always propagate
    },
    async fetchEvent() {
      this.loading = true
      let x = await api.apiFetch(`/diabetes/events?id=${this.id}`)
      if (x.ok) {
        let text = await x.text()
        if (text) {
          this.item = JSON.parse(text)
        } else {
          this.item = {
            id: this.id,
            type: this.type,

            when: this.getCurrentDateTimeLocal(),
          }
          //for ad-hoc intakes, default to 1
          if (this.item.type == 'intake' && !this.item.value) this.item.value = 1

          //try to guess meal
          if (this.item.type == 'meal' && !this.item.meal) {
            this.item.meal = this.guessMeal()
          }
        }
      }
      this.loading = false
    },
    guessMeal() {
      let h = new Date().getHours()
      let m = new Date().getMinutes()
      m = m + h * 60

      if (m < 4 * 60) {
        return 'dinner'
      } else if (m < 11 * 60) {
        return 'breakfast'
      } else if (m < 14 * 60) {
        return 'morning-snack'
      } else if (m < 17.5 * 60) {
        return 'lunch'
      } else if (m < 21 * 60) {
        return 'evening-snack'
      } else {
        return 'dinner'
      }
    },
    cancel() {
      this.$emit('done', false)
    },
    async deleteItem() {
      let conf = confirm('Are you sure?')
      if (!conf) return

      let x = await api.apiFetch(`/diabetes/events?id=${this.item.id}`, {
        method: 'DELETE',
      })
      if (x.ok) {
        this.$emit('done', true)
      } else {
        alert('Something went wrong it seems')
      }
    },
    async save() {
      this.loading = true
      let x = await api.apiFetch('/diabetes/events', {
        method: 'POST',
        body: JSON.stringify(this.item),
      })
      if (x.ok) {
        let j = await x.json()
        if (j.coach?.reaction) {
          alert(j.coach?.reaction)
        }
        this.$emit('done', true)
      }
      this.loading = false
    },
    getCurrentDateTimeLocal() {
      const now = new Date()
      const offset = now.getTimezoneOffset()
      const adjustedDate = new Date(now.getTime() - offset * 60 * 1000)
      return adjustedDate.toISOString().slice(0, 16)
    },
    formatTime(minutes) {
      if (minutes < 60) {
        return minutes + ' min'
      } else {
        const h = Math.floor(minutes / 60)
        const m = minutes % 60
        return `${h}hr ${m}min`
      }
    },
  },
  mounted() {
    this.fetchEvent()
  },
}
</script>

<style lang="scss" scoped></style>
